import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  callMedicalRecordVisit,
  listMedicalRecordQueue,
  searchMedicalDepartments,
  searchMedicalDoctors,
} from "../../services/medicalRecordService";

const today = () => new Date().toISOString().slice(0, 10);

const initialState = {
  rows: [],
  loading: false,
  calling: false,
  error: null,
  filters: {
    fromDate: today(),
    toDate: today(),
    departmentId: "",
    doctorId: "",
    q: "",
    status: "All",
  },
  departments: [],
  doctors: [],
};

export const fetchMedicalRecordQueue = createAsyncThunk(
  "medicalRecord/fetchQueue",
  async (filters, { rejectWithValue }) => {
    try {
      return await listMedicalRecordQueue(filters);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const callVisit = createAsyncThunk(
  "medicalRecord/callVisit",
  async (visitId, { rejectWithValue }) => {
    try {
      return await callMedicalRecordVisit(visitId);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMedicalDepartments = createAsyncThunk(
  "medicalRecord/fetchDepartments",
  async (q, { rejectWithValue }) => {
    try {
      return await searchMedicalDepartments(q);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMedicalDoctors = createAsyncThunk(
  "medicalRecord/fetchDoctors",
  async (q, { rejectWithValue }) => {
    try {
      return await searchMedicalDoctors(q);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const medicalRecordSlice = createSlice({
  name: "medicalRecord",
  initialState,
  reducers: {
    setMedicalRecordFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedicalRecordQueue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMedicalRecordQueue.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload;
      })
      .addCase(fetchMedicalRecordQueue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load queue";
      })
      .addCase(callVisit.pending, (state) => {
        state.calling = true;
      })
      .addCase(callVisit.fulfilled, (state) => {
        state.calling = false;
      })
      .addCase(callVisit.rejected, (state, action) => {
        state.calling = false;
        state.error = action.payload || "Failed to call patient";
      })
      .addCase(fetchMedicalDepartments.fulfilled, (state, action) => {
        state.departments = action.payload;
      })
      .addCase(fetchMedicalDoctors.fulfilled, (state, action) => {
        state.doctors = action.payload;
      });
  },
});

export const { setMedicalRecordFilters } = medicalRecordSlice.actions;
export default medicalRecordSlice.reducer;
